import { useEffect, useRef } from 'react';

/** Returns the previous value of `variable` in a given render */
export function usePreviousValue<T>(variable: T, initialValue: T | null = null) {
  const ref = useRef<T | null>(initialValue);

  useEffect(() => {
    ref.current = variable;
  }, [variable]);

  // This happens before the update in useEffect, so it's effectively returning the previous value
  return ref.current;
}
